import { DashboardComponentPair } from '../../../../models/dashboard';
import { JobResultAnalyticsDashboardComponent } from './job-result-analytics-dashboard.component';
import { JobResultAnalyticsDashboardFormComponent } from './job-result-analytics-dashboard-form.component';

export const ComponentPair: DashboardComponentPair = {
  view: JobResultAnalyticsDashboardComponent,
  form: JobResultAnalyticsDashboardFormComponent,
};
